import { appConfigAPI } from '@/providers/apis/app/app-config';
import { dataLakeAPI } from '@/providers/apis/data-lake/data-lake';
import { appConfigService } from '@/providers/services/app/app-config';
import moment from 'moment';
import { Vue, Component, Watch } from 'vue-property-decorator';

@Component({
    name: 'dl-reports',
})

export default class DLReports extends Vue {
    // ----------------------------------------------------------
    // Properties

    private dateRange: {startDate: string, endDate: string} = {
        startDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
    };

    @Watch('$route.query')
    private onWatchQuery() {
        this.updatedQueryParams();
    }

    // ----------------------------------------------------------
    // Hooks

    private created() {
        this.updatedQueryParams();
    }


    // ----------------------------------------------------------
    // Actions


    // ----------------------------------------------------------
    // Methods

    private updatedQueryParams() {
        const { query } = this.$route;
        if (query && Object.keys(query).length) {
            this.dateRange = {
                startDate: query.startDate as string,
                endDate: query.endDate as string,
            };
        }
    }

}
